<template>
    <div class="page filtersSlide noTopPadding">
        <!--v-touch:swipe.stop-->
        
        <div class="filtersContainer">
            
            <div class="container">
                <h2 class="title mb-4">
                    <span><img :src="getStaticImage('icon-arrow-left.png')" @click="$router.go(-1)" alt="back"></span>
                    <span class="text-center" v-if="getLng() == 'en'">{{ this.selectedFilter ? this.selectedFilter.name : "Filters"}}</span>
                    <span class="text-center" v-else>{{ this.selectedFilter ? this.selectedFilter.spanish_name : "Filters"}}</span>
                    <span class="text-right">
                        <router-link class="mkButton mkBig searchButton" @click.native="settings.show_filters = false"
                                     :to="{name:'recipes'}">{{ $t('filters.Recipes')}}
                        </router-link>
                    </span>
                </h2>
                
                
                <!--##############################-->
                <h3 class="text-center mb-4">
                    {{ $t('filters.Recipes' )}} <span v-if="showTotal"> ({{searchResults.total}})</span>
                </h3>
                
                
                <!--#############Selected filters#################-->
                <transition name="fadeHeight">
                    <div v-if="Object.keys(selectedFilterList).length || searchData.keywords.length" style="animation-duration: 0.5s">
                        <div class="d-flex justify-content-between align-items-center mb-4">
                            <strong>Selected Filters</strong>
                            <div class="mkButton mkBig mkGray" @click="clearAll">
                                Clear All
                            </div>
                        </div>
                        
                        <div class="selectedList mb-4">
                            <div
                                v-for="filter in selectedFilterList"
                                class="selectedFilter"
                                @click="toggleFilter(filter)"
                                :key="filter.id"
                            >
                                {{filter.name}}
                                <img :src="getStaticImage('icon-clear.png')" alt="">
                            </div>
                            <div
                                v-for="keyword in searchData.keywords"
                                class="selectedFilter"
                                @click="deleteKeyword(keyword)"
                                :key="keyword"
                            >
                                {{keyword}}
                                <img :src="getStaticImage('icon-clear.png')" alt="">
                            </div>
                        </div>
                    </div>
                </transition>
                
                
                <!--##############################-->
                
                <div class="keywordsBox mb-4" v-if="getLng() == 'en'">
                    <input
                        type="text"
                        placeholder="Keyword"
                        v-model="newKeyword"
                        @keypress.enter="addKeyword"
                    >
                </div>
                <div class="keywordsBox mb-4" v-else>
                    <input
                        type="text"
                        placeholder="Palabra clave"
                        v-model="newKeyword"
                        @keypress.enter="addKeyword"
                    >
                </div>
            </div>
            
            <!--##############################-->
            <!--parents-->
            
            
            <transition name="fade">
                <transition-group
                    appear
                    class="filterList"
                    enter-active-class="fadeInLeft"
                    leave-active-class="fadeOutRight"
                    style="animation-duration: 1.5s"
                    tag="div"
                    v-if="selectedFilter"
                    :key="selectedFilter.id"
                >
                    <div
                        v-for="filter in sortedChildren"
                        v-if="filter && startAnimation && filter.slug !== 'seasonal'"
                        class="listItem d-flex justify-content-between align-items-center"
                        @click="toggleFilter(filter)"
                        :key="filter.id"
                    >
                        <span v-if="getLng() == 'en'">{{filter.name}}</span>
                        <span v-else>{{ filter.spanish_name }}</span>
                        <div class="selectedFilters"  v-if="filter.children.length" >
                            {{ displaySelectedFilters(filter) }}
                        </div>
                        
                        <img v-if="filter.children.length" width="20" :src="getStaticImage('icon-arrow-left.png')"
                             class="next" alt="">
                        <div
                            v-else
                            :class="{ active : ( searchData.filters.indexOf(filter.id) != -1 ) }"
                            class="circle"
                        ></div>
                    </div>
                </transition-group>
            </transition>
        
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";


    export default {
        name: "Filters",
        data() {
            return {
                startAnimation: false,
                selectedFilter: false,
                showTotal: false,
                newKeyword: ""
            }
        },
        methods: {
            addKeyword() {
                this.newKeyword = this.newKeyword.trim();
                if (this.searchData.keywords.indexOf(this.newKeyword) === -1) {
                    this.searchData.keywords.push(this.newKeyword)
                }
                this.newKeyword = "";
                this.$store.commit("search/unsetSearchList");
                this.$store.dispatch("search/getRecipes");
            },
            deleteKeyword(keyword) {
                const index = this.searchData.keywords.indexOf(keyword);
                if (index != -1) {
                    this.searchData.keywords.splice(index, 1)
                }
                this.$store.commit("search/unsetSearchList");
                this.$store.dispatch("search/getRecipes");
            },
            displaySelectedFilters(filter) {
                let text = "";
                filter.children.forEach((el)=>{
                    if (el.children.length){
                        text += this.displaySelectedFilters(el)
                    }else if(el.selected){
                        text += el.name + ", ";
                    }
                });
                return text.replace(/,\s*$/, "");
            },
            toggleFilter(filter) {
                
                if (filter.children.length) {
                    this.selectedFilter = filter;
                    this.$router.push( {name: 'recipes',  query : {page_filter: this.selectedFilter.id}  } )
                    return 1;
                }

                const id = filter.id;
                filter.selected = true;
                let index = this.searchData.filters.indexOf(id);
                if (index === -1) {
                    this.searchData.filters.push(id);
                    this.selectedFilterList[id] = filter;
                } else {
                    this.searchData.filters.splice(index, 1);
                    this.selectedFilterList[id].selected = false;
                    delete this.selectedFilterList[id];
                }

                this.$store.commit("search/unsetSearchList");
                this.$store.dispatch("search/getRecipes");
            },
            clearAll() {
                this.$store.commit("search/unsetSelectedFilterList");
                this.$store.dispatch("search/getRecipes");
            },
            findFilters(arr, id) {
                if (!Array.isArray(arr)) arr = [arr];
                return arr.find(item => item.id === id)
                        || arr.reduce((found, curr) => found || this.findFilters(curr.children, id), undefined)
            },
            initFilters(){
                const id = parseInt(this.$route.query.page_filter);
                if (this.selectedFilter === id) return 0;
                if (!id) {
                    this.selectedFilter = this.filters
                }else{
                    this.selectedFilter = this.findFilters(this.filters,id);
                }
            },
            checkTotal(){
                if (Object.keys(this.selectedFilterList).length){
                    this.showTotal = true;
                }else{
                    this.showTotal = false;
                }
            },
            getLng() {
                return localStorage.getItem( 'lng' ) || 'en';
            }

        },
        computed: {
            ...mapState("search", ["filters", "searchResults", "searchData", "selectedFilterList", ""]),
            ...mapState("shared", ["settings", 'preloaded']),
            sortedChildren(){
                if (this.selectedFilter.sorted !== false){
                    return this.selectedFilter.children.sort((a,b) => {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)})
                }else{
                    return this.selectedFilter.children;
                }
                
            }
        },
        mounted() {
            this.startAnimation = true;
        },
        created() {
            this.initFilters();
            this.checkTotal();
        },
        watch:{
            "$route.query.page_filter"(){
                this.initFilters();
            },
            "searchResults.total"(){
                this.checkTotal();
            }
        }
        
    }
</script>
